// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CloudUploadIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CloudUpload/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 10a4 4 0 0 0 4 4h3v3a1 1 0 1 0 2 0v-3h3a4 4 0 0 0 0-8 4 4 0 0 0-8 0 4 4 0 0 0-4 4Zm9 4H9V9.414l-1.293 1.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L11 9.414V14Z",
  clipRule: "evenodd"
}));
export default CloudUploadIcon;